
import { createSlice } from "@reduxjs/toolkit";
import { INPNState,npnInitialState } from "./initialState";
import { AppConfigExtended, NCSHealthResponse, NetworkConnectionTypes, SessionDetails, appPhase } from "../../shared/typings";
import { LoggPrefix } from "../../shared/util";
export const npnReducerSlice = createSlice({
    name:'npnAppState',
    initialState:npnInitialState,
    reducers:{
        createSetNetworkConnection(state:INPNState,action:{type:string,payload:NetworkConnectionTypes}){
            state.npnAppState.networkConnection= action.payload 
        },
        createSetNCSDDetails(state:INPNState,action:{type:string,payload?:NCSHealthResponse}){
            if(action.payload){
                state.npnAppState.ncsDetails= action.payload
            }
            else {
                state.npnAppState.ncsDetails= undefined
                state.npnAppState.ncsHealthURI= undefined
            } 
        },
        createSetNCSHealthURI(state:INPNState,action:{type:string,payload:{input: string,
            ncsConfig:AppConfigExtended["ncsServices"], isIP?: boolean}}){
            const payload = action.payload;  
            const ncsConfig = action.payload.ncsConfig//state.appState.configuration?.ncsServices   
            const parseCode = (str: string)=>{
                const digits = str.match(/\d+/g)?.join('');
                return digits;
            }
            if(ncsConfig){
                const ncsIP = payload.isIP ? action.payload.input : `${ncsConfig.defaultDomain}${parseCode(action.payload.input)}`
                state.npnAppState.ncsHealthURI = `${ncsConfig.protocol}${ncsIP}:${ncsConfig.port}/${ncsConfig.ncsHealth}`  
            }
        },
        createClearNCSHealthURI (state:INPNState){
            state.npnAppState.ncsHealthURI = undefined
            state.npnAppState.ncsDetails = undefined
        },
        createSetInitiliizeOnlineFlow (state:INPNState){
            state.initilizeOnlineFlow = true;
        },
        createSetInitiliizeOfflineFlow (state:INPNState){
           state.appState.currentPhase= state.npnFlow[0].name
        },
        createResetPhase(state: INPNState){
            const currentPhaseIndx = state.npnFlow.findIndex(phase=>phase.name === state.appState.currentPhase);
            state.npnFlow[currentPhaseIndx].status = "NotStarted";
            if(state.npnFlow[currentPhaseIndx-1]){
            state.npnFlow[currentPhaseIndx-1].status = "InProgress";
            state.appState.currentPhase = state.npnFlow[currentPhaseIndx-1].name; 
            }
        },
        createSetCurrentPhase(state:INPNState,action:{payload:appPhase["name"]} ){
            const currentPhaseIndx = state.npnFlow.findIndex(phase=>phase.name === action.payload);
            state.npnFlow[currentPhaseIndx].status = "InProgress";
            state.appState.currentPhase = action.payload; 
        },
        createSetNextPhase(state:INPNState,action:{type:string,payload:appPhase["status"],nextPhase?:appPhase["name"]} ){
        if(action.nextPhase){
            const currentPhaseIndx = state.npnFlow.findIndex(phase=>phase.name === action.nextPhase);
            state.npnFlow[currentPhaseIndx].status = "InProgress";
            state.appState.currentPhase = action.nextPhase;
        }   
        else {
            //find current phase
        const currentPhase = state.npnFlow.find(phase=>phase.name === state.appState.currentPhase) ;
        const currentPhaseIndx = state.npnFlow.findIndex(phase=>phase.name === state.appState.currentPhase);
         if(currentPhase){
            currentPhase.status = action.payload;
            const nextPhase = state.npnFlow[currentPhaseIndx+1]?.name
            if(action.payload === "Completed" || action.payload === "Skipped"){
                console.log(LoggPrefix,"current phase -->", currentPhase?.name,"next phase --> ",nextPhase);
                if(nextPhase){
                    state.npnFlow[currentPhaseIndx+1].status = "InProgress";
                    state.appState.currentPhase = state.npnFlow[currentPhaseIndx+1]?.name   
                }
             }
              } 
        }
       
        },
        createRedirectToSCI(state:INPNState){
            state.appState.currentView = "RedirectionView";
            state.sessionState.lastKnownGoodState = "RedirectionView";
        },
        createSetDateTimeCheck(state:INPNState,action:{type:string,payload:boolean}){
            state.deviceState.isDateTimeValid  = action.payload
        }, 
        returnHomeAction(state:INPNState){
            state.appState.currentPhase = "ModeSelection";
            state.npnAppState.ncsDetails = undefined;
            state.npnAppState.ncsHealthURI = undefined; 
            state.npnAppState.classroomServerCode = undefined
        }, 
        createSetServerCode(state:INPNState,action:{type:string,payload:string}){
            state.npnAppState.classroomServerCode  = action.payload;
        }, 
        createSetNPNSessionDetailsAction(state:INPNState,action:{type:string,payload:Record<string, unknown>}){
            const sessionDetails= action.payload as SessionDetails
                state.appState={
                ...state.appState,
                appLaunchId:sessionDetails.appLaunchId,
                environment: sessionDetails.environment,
                runtimePlatform: sessionDetails.runtimePlatform,
                isPageReloaded: sessionDetails.isPageReloaded,
                extensionVersion: sessionDetails.extensionVersion
               }, 
               state.sessionState={
                ...state.sessionState,
                tryAgainAfterFailure: false,
                networkConnectionState: sessionDetails.networkConnectionState ? sessionDetails.networkConnectionState : state.sessionState.networkConnectionState
               },
                state.deviceState={
                    ...state.deviceState,
                    deviceId: sessionDetails.deviceId,
                    deviceIdType: sessionDetails.deviceIdType,
                    deviceModel: sessionDetails.deviceModel,
                    deviceType: sessionDetails.deviceType,
                    systemInfo: sessionDetails.systemInfo
                },
                state.updateState.isCheckForUpdateEnabled= sessionDetails?.isCheckForUpdateEnabled !== undefined ? sessionDetails.isCheckForUpdateEnabled : false
            }   
    }
})
export const { 
    createSetDateTimeCheck,
    createRedirectToSCI,
    createSetNPNSessionDetailsAction,
    createSetNetworkConnection,
    createSetInitiliizeOnlineFlow,
    createSetInitiliizeOfflineFlow,
    createSetNextPhase,
    createResetPhase,
    createSetNCSHealthURI,
    createSetNCSDDetails,
    returnHomeAction,
    createSetServerCode,
    createClearNCSHealthURI,
    createSetCurrentPhase
     } = npnReducerSlice.actions
export default npnReducerSlice.reducer
